'use strict';

var Sugar = require('sugar-core');

require('../date/build/buildNumberUnitMethodsCall');

module.exports = Sugar.Number.day;


//////////////////
// WEBPACK FOOTER
// ./~/sugar-date/number/day.js
// module id = 322
// module chunks = 1